export default "__VITE_ASSET__DRUXst6W__"